export default __webpack_public_path__ + "static/manuela-a64a86cd2e9df36b125daafd94bf9ddb.jpg";